{
  "appTitle": "BACK OFFICE",
  "changelog": {
    "title": "Änderungsprotokoll",
    "description": "Was ist neu im Back Office"
  },
  "errors": {
    "loadFailed": "Details konnten nicht geladen werden."
  },
  "accessDenied": {
    "title": "Zugriff verweigert",
    "description": "Sie haben keine Berechtigung, diese Seite anzuzeigen.",
    "missingPermission": "Fehlende Berechtigung: {{permission}}",
    "backToHome": "Zurück"
  },
  "noAccess": {
    "title": "Kein Zugriff",
    "description": "Ihr Konto ist nicht berechtigt, das Backoffice zu nutzen.",
    "hint": "Wenden Sie sich an Ihren Administrator, um Zugriff anzufordern.",
    "signedInAs": "Angemeldet als {{email}}",
    "signOut": "Abmelden"
  },
  "nav": {
    "management": "Verwaltung",
    "iam": "Identität und Zugriff",
    "ingress": "Dateneingang",
    "octo": "Octo",
    "hardware": "Hardware"
  },
  "home": {
    "title": "Startseite"
  },
  "users": {
    "tools": {
      "menuLabel": "Werkzeuge",
      "lastLogin": "Verteilung der letzten Anmeldungen"
    },
    "lastLoginChart": {
      "title": "Verteilung der letzten Anmeldungen",
      "description": "Wann sich Benutzer, die dem aktuellen Filter entsprechen, zuletzt angemeldet haben.",
      "empty": "Keine Anmeldeaktivität für die aktuelle Auswahl.",
      "neverNote": "Nie angemeldet: {{count}}",
      "tooltipTotal": "Gesamt"
    },
    "title": "Benutzer",
    "list": {
      "columns": {
        "id": "ID",
        "publicId": "Öffentliche ID",
        "userName": "Benutzername",
        "email": "E-Mail",
        "fullName": "Vollständiger Name",
        "realm": "Bereich",
        "defaultStore": "Standardfiliale",
        "mfa": "MFA",
        "lastLoginAt": "Letzter Login",
        "lastAttemptAt": "Letzter Versuch",
        "status": "Status",
        "createdAt": "Erstellt"
      },
      "actions": {
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren",
        "changeStore": "Store wechseln",
        "delete": "Benutzer löschen",
        "cannotModifySelf": "Sie können Ihr eigenes Konto nicht deaktivieren oder löschen"
      },
      "addUserButton": "Benutzer erstellen",
      "searchPlaceholder": "Benutzer suchen...",
      "filter": {
        "realm": "Bereich",
        "searchRealms": "Bereiche suchen…",
        "noRealms": "Keine Bereiche gefunden",
        "chain": "Kette",
        "searchChains": "Ketten suchen…",
        "noChains": "Keine Ketten gefunden",
        "store": "Filiale",
        "searchStores": "Filialen suchen…",
        "noStores": "Keine Filialen gefunden"
      }
    },
    "dialog": {
      "createTitle": "Benutzer erstellen",
      "comingSoon": "Demnächst verfügbar",
      "deactivateTitle": "Benutzer deaktivieren",
      "activateTitle": "Benutzer aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivateWarning": "Dieser Benutzer verliert sofort den Zugang zu focalOS.",
      "deactivateConfirm": "Deaktivieren",
      "activateConfirm": "Aktivieren"
    },
    "deleteDialog": {
      "title": "Benutzer löschen",
      "prompt": "Möchten Sie wirklich dauerhaft löschen",
      "warning": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "confirm": "Löschen"
    },
    "changeStoreDialog": {
      "title": "Standard-Store ändern",
      "description": "Neuen Standard-Store festlegen für",
      "storeLabel": "Standard-Store",
      "selectStore": "Store auswählen",
      "searchStores": "Stores suchen…",
      "noStores": "Keine Stores gefunden",
      "removePrevious": "Vorherige Standardfiliale aus verfügbaren Filialen entfernen",
      "save": "Speichern"
    },
    "form": {
      "email": "E-Mail",
      "username": "Benutzername",
      "fullName": "Vollständiger Name",
      "realm": "Bereich",
      "selectRealm": "Bereich auswählen",
      "searchRealms": "Bereiche suchen…",
      "noRealms": "Keine Bereiche gefunden",
      "realmChangeWarning": "Das Ändern des SSO-Bereichs entfernt das Passwort des Benutzers aus der Datenbank; eine Wiederherstellung des ursprünglichen Passworts ist nicht möglich.",
      "notRequired": "Nicht erforderlich",
      "password": "Passwort",
      "passwordEditPlaceholder": "Leer lassen, um das aktuelle zu behalten",
      "validationDisabled": "Validierung deaktiviert",
      "validationDisabledHint": "Admin-Gruppenmitglieder können Passwörter ohne Komplexitätsanforderungen festlegen",
      "groups": "Gruppen",
      "selectGroups": "Gruppen auswählen",
      "searchGroups": "Gruppen suchen…",
      "noGroups": "Keine Gruppen gefunden",
      "defaultStore": "Standardfiliale",
      "selectStore": "Filiale auswählen",
      "searchStores": "Filialen suchen…",
      "noStores": "Keine Filialen gefunden",
      "availableStores": "Verfügbare Filialen",
      "selectAvailableStores": "Filialen auswählen",
      "validation": {
        "required": "Erforderlich",
        "invalidEmail": "Muss eine gültige E-Mail sein",
        "passwordMinLength": "Passwort muss mindestens 8 Zeichen lang sein",
        "emailExists": "Ein Benutzer mit dieser E-Mail existiert bereits",
        "usernameExists": "Ein Benutzer mit diesem Benutzernamen existiert bereits"
      },
      "ftFueTraining": "FT FUE-Schulung",
      "requirePasswordReset": "Passwort-Zurücksetzung erforderlich",
      "flags": "Flags",
      "selectFlags": "Flags auswählen",
      "searchFlags": "Flags suchen…",
      "noFlags": "Keine Flags gefunden",
      "supervisor": "Vorgesetzter",
      "selectSupervisor": "Vorgesetzten auswählen",
      "searchSupervisor": "Personen suchen…",
      "noSupervisor": "Keine Personen gefunden"
    },
    "detail": {
      "profileTitle": "Profil",
      "fullName": "Vollständiger Name",
      "groupsTitle": "Gruppen",
      "permissionsTitle": "Berechtigungen",
      "directlyAssigned": "Direkt zugewiesen",
      "availableStores": "Verfügbare Filialen"
    },
    "notifications": {
      "activated": "Benutzer \"{{name}}\" aktiviert",
      "deactivated": "Benutzer \"{{name}}\" deaktiviert",
      "created": "Benutzer \"{{name}}\" erstellt",
      "updated": "Benutzer \"{{name}}\" aktualisiert",
      "deleted": "Benutzer \"{{name}}\" gelöscht",
      "createFailed": "Benutzer konnte nicht erstellt werden"
    },
    "permissions": {
      "view": "Anzeigen",
      "edit": "Bearbeiten",
      "fullAccess": "Vollzugriff",
      "everyBackofficePermission": "Jede Backoffice-Berechtigung",
      "everyPermission": "Jede Berechtigung (Superuser)",
      "allPermissions": "Alle {{section}}-Berechtigungen",
      "grantedVia": "Gewährt über {{permission}}",
      "inheritedFromGroup": "Geerbt von Gruppe „{{group}}“",
      "inheritBanner": {
        "prefix": "Dieser Benutzer erbt Berechtigungen von",
        "suffix": "Geerbte Berechtigungen werden gesperrt angezeigt und können hier nicht geändert werden."
      },
      "labels": {
        "approvals": "Genehmigungen",
        "chains": "Ketten",
        "regions": "Regionen",
        "settings": "Einstellungen",
        "activity": "Aktivität",
        "stores": "Filialen",
        "operations": "Betrieb",
        "health": "Zustand",
        "hardware": "Hardware",
        "schedule": "Zeitplan",
        "cutOffTimes": "Cut-Off-Zeiten",
        "map": "Karte",
        "chainValues": "Kettenwerte",
        "storeValues": "Filialwerte",
        "iam": "IAM",
        "users": "Benutzer",
        "groups": "Gruppen",
        "vendors": "Lieferanten",
        "permissions": "Berechtigungen",
        "sso": "SSO",
        "ingress": "Ingress",
        "imports": "Importe",
        "transformations": "Transformationen",
        "octo": "Octo",
        "rules": "Regeln",
        "visualizer": "Visualizer",
        "action": "Action",
        "adaOrder": "AdaOrder",
        "adaPogs": "AdaPOGs",
        "backofficeLegacy": "Backoffice (legacy)",
        "developer": "Entwickler",
        "exec": "Exec",
        "fieldTool": "Außendienst-Tool",
        "impact": "Impact",
        "messages": "Nachrichten",
        "productRecognition": "Produkterkennung",
        "psi": "PSI",
        "review": "Überprüfung",
        "setup": "Einrichtung",
        "devices": "Geräte",
        "firmware": "Firmware",
        "blackhat": "Blackhat",
        "deployment": "Bereitstellung",
        "factoryQa": "Werks-QA",
        "fieldDeployment": "Feld-Bereitstellung",
        "fieldIms": "Feld-IMS",
        "fieldMaintenanceVisit": "Feld-Wartungsbesuche",
        "fieldQa": "Feld-QA",
        "fieldSetup": "Feld-Einrichtung",
        "fieldStatus": "Feld-Status",
        "fieldStore": "Feld-Filialbefehle",
        "fieldTasks": "Feld-Aufgaben",
        "ims": "IMS-Sendungen",
        "imsAddresses": "IMS-Adressen",
        "labelPrint": "Etikettendruck",
        "opsTasks": "Betriebsaufgaben",
        "otaVersions": "OTA-Versionen",
        "payment": "Zahlung",
        "payroll": "Lohnabrechnung",
        "storeAccess": "Filialzugriff"
      }
    }
  },
  "groups": {
    "title": "Gruppen",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "description": "Beschreibung",
        "noOfUsers": "Benutzer",
        "createdAt": "Erstellt"
      },
      "addGroupButton": "Gruppe erstellen",
      "searchPlaceholder": "Gruppen suchen..."
    },
    "dialog": {
      "createTitle": "Gruppe erstellen"
    },
    "form": {
      "name": "Name",
      "description": "Beschreibung",
      "validation": {
        "required": "Erforderlich",
        "nameFormat": "Verwenden Sie Kleinbuchstaben, Ziffern und Unterstriche (max. 32 Zeichen)"
      }
    },
    "notifications": {
      "created": "Gruppe \"{{name}}\" erstellt",
      "updated": "Gruppe \"{{name}}\" aktualisiert"
    }
  },
  "permissions": {
    "title": "Berechtigungen"
  },
  "visualizer": {
    "title": "Visualisierer"
  },
  "sso": {
    "title": "Einmaliges Anmelden",
    "pageTitle": "Einmaliges Anmelden — Domains"
  },
  "vendors": {
    "title": "Anbieter",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "apiKey": "API-Schlüssel",
        "chain": "Kette",
        "status": "Status",
        "createdAt": "Erstellt"
      },
      "searchPlaceholder": "Anbieter suchen...",
      "filter": {
        "chain": "Kette",
        "searchChains": "Ketten suchen…",
        "noChains": "Keine Ketten gefunden"
      },
      "actions": {
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren"
      },
      "addVendorButton": "Anbieter erstellen"
    },
    "notifications": {
      "activated": "Anbieter \"{{name}}\" aktiviert",
      "deactivated": "Anbieter \"{{name}}\" deaktiviert",
      "created": "Anbieter \"{{name}}\" erstellt"
    },
    "dialog": {
      "deactivateTitle": "Anbieter deaktivieren",
      "activateTitle": "Anbieter aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivateWarning": "Dieser Anbieter verliert sofort den Zugang zur Ingress- und Export-API.",
      "deactivateConfirm": "Deaktivieren",
      "activateConfirm": "Aktivieren",
      "createTitle": "Anbieter erstellen",
      "createdTitle": "Anbieter erstellt",
      "createdWarning": "Kopieren Sie den privaten Schlüssel jetzt – er wird nicht erneut angezeigt.",
      "apiKeyLabel": "API-Schlüssel",
      "privateKeyLabel": "Privater Schlüssel"
    },
    "form": {
      "name": "Name",
      "chain": "Kette",
      "selectChain": "Kette auswählen",
      "searchChains": "Ketten suchen…",
      "noChains": "Keine Ketten gefunden",
      "validation": {
        "required": "Erforderlich",
        "nameMaxLength": "Name darf höchstens 32 Zeichen lang sein",
        "nameFormat": "Nur Kleinbuchstaben, Ziffern und Unterstriche sind erlaubt"
      }
    },
    "usage": {
      "kind": {
        "ingress": "Eingang",
        "export": "Export"
      },
      "columns": {
        "id": "ID",
        "usage": "Nutzung",
        "type": "Typ",
        "store": "Filiale",
        "chain": "Kette",
        "source": "Quelle",
        "status": "Status",
        "createdAt": "Erstellt"
      },
      "storeDeleted": "{{id}} (gelöscht)"
    }
  },
  "ingressImports": {
    "title": "Importe"
  },
  "transformations": {
    "title": "Transformationen",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "key": "Schlüssel",
        "target": "Ziel",
        "outputTypes": "Ausgabetypen",
        "status": "Status",
        "createdAt": "Erstellt"
      },
      "addButton": "Transformation erstellen",
      "searchPlaceholder": "Transformationen suchen...",
      "actions": {
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren",
        "viewSessions": "Sitzungen anzeigen"
      },
      "filter": {
        "chain": "Kette",
        "store": "Filiale"
      }
    },
    "dialog": {
      "createTitle": "Transformation erstellen",
      "comingSoon": "Demnächst",
      "deactivateTitle": "Transformation deaktivieren",
      "activateTitle": "Transformation aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivateWarning": "Überprüfen Sie vor dem Deaktivieren der Transformation, ob sie nicht in SFTP-/E-Mail-Importern verwendet wird.",
      "deactivateConfirm": "Deaktivieren",
      "activateConfirm": "Aktivieren"
    },
    "detail": {
      "title": "Transformationsdetails",
      "comingSoon": "Demnächst",
      "tabs": {
        "info": "Info",
        "files": "Dateien",
        "sql": "SQL",
        "activityLog": "Aktivität"
      },
      "fields": {
        "id": "ID",
        "shortName": "Kurzname",
        "description": "Beschreibung",
        "target": "Ziel",
        "outputTypes": "Ausgabetypen",
        "perStore": "Pro Filiale",
        "onlyLiveStores": "Nur aktive Filialen",
        "status": "Status",
        "createdAt": "Erstellt",
        "inputFiles": "Eingabedateien",
        "yes": "Ja",
        "no": "Nein",
        "updatedAt": "Aktualisiert",
        "sqlContent": "SQL-Abfrage",
        "sqlContentLabel": "SQL-Inhalt",
        "copyToClipboard": "Kopieren",
        "noFiles": "Keine Eingabedateien definiert",
        "noSql": "Kein SQL-Inhalt",
        "fileType": "Dateityp",
        "exampleFileName": "Beispieldatei",
        "variesPerStore": "Variiert pro Filiale",
        "regex": "Regex",
        "forcedFix": "Erzwungene Korrektur",
        "loadExtras": "Zusätzliche Ladeoptionen",
        "validateColumns": "Spaltenvalidierung",
        "checkDate": "Datumsüberprüfung",
        "targetName": "Zielname"
      }
    }
  },
  "rules": {
    "title": "Regeln"
  },
  "chains": {
    "title": "Ketten",
    "tabs": {
      "info": "Info",
      "edit": "Bearbeiten",
      "settings": "Einstellungen",
      "regions": "Regionen",
      "stores": "Filialen",
      "cutOffTimes": "Cut-Off-Zeiten",
      "imports": "Importe",
      "activityLog": "Aktivität"
    },
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Name",
        "chainName": "Schlüssel",
        "timezone": "Zeitzone",
        "numberOfStores": "Filialen",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplizieren",
        "compareSettings": "Einstellungen vergleichen"
      },
      "searchPlaceholder": "Ketten suchen...",
      "filter": {},
      "addChainButton": "Kette erstellen"
    },
    "form": {
      "legibleName": "Anzeigename",
      "chainName": "Kettenname",
      "defaultTimeZone": "Standard-Zeitzone",
      "copySettings": "Einstellungen aus einer bestehenden Kette kopieren",
      "selectTimezone": "Zeitzone auswählen",
      "searchTimezones": "Zeitzonen suchen…",
      "noTimezones": "Keine Zeitzonen gefunden",
      "selectCopyFrom": "Quellkette auswählen",
      "searchCopyFrom": "Ketten suchen…",
      "noCopyFrom": "Keine Ketten gefunden",
      "chainNameExists": "Eine Kette mit diesem Namen existiert bereits",
      "legibleNameExists": "Eine Kette mit diesem Anzeigenamen existiert bereits"
    },
    "dialog": {
      "createTitle": "Kette erstellen",
      "duplicateTitle": "Kette duplizieren"
    },
    "info": {
      "fields": {
        "displayName": "Anzeigename",
        "chainName": "Kettenname",
        "defaultTimeZone": "Standardzeitzone",
        "status": "Status",
        "stores": "Filialen"
      },
      "storeSummary": "{{active}} aktiv von {{total}}"
    },
    "compare": {
      "title": "Einstellungen vergleichen",
      "onlyDiffs": "Unterschiede",
      "noDifferences": "Keine Unterschiede gefunden",
      "dialog": {
        "title": "Ketteneinstellungen vergleichen",
        "description": "Wählen Sie zwei Ketten aus, um deren Einstellungen zu vergleichen.",
        "sourceLabel": "Quellkette",
        "targetLabel": "Vergleichen mit",
        "pickChain": "Kette auswählen…",
        "compare": "Vergleichen"
      }
    },
    "notifications": {
      "created": "Kette \"{{name}}\" erstellt",
      "updated": "Kette \"{{name}}\" aktualisiert"
    },
    "storeCount_one": "{{count}} Filiale",
    "storeCount_other": "{{count}} Filialen",
    "regions": {
      "columns": {
        "regionName": "Regionname",
        "storesCount": "Filialen"
      }
    }
  },
  "stores": {
    "title": "Filialen",
    "missingDataWarning": "Der Filiale fehlen Daten. Bitte geben Sie die Werte an und speichern Sie.",
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Name",
        "chain": "Kette",
        "storeName": "Schlüssel",
        "storeCode": "Filialcode",
        "regionName": "Region",
        "timezone": "Zeitzone",
        "openTime": "Öffnet",
        "closeTime": "Schließt",
        "goLiveDate": "Inbetriebnahme",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplizieren",
        "deactivate": "Deaktivieren",
        "activate": "Aktivieren",
        "archive": "Archivieren",
        "compareSettings": "Einstellungen vergleichen",
        "tools": "Werkzeuge",
        "triggerShc": "SHC von API abrufen"
      },
      "searchPlaceholder": "Filialen suchen...",
      "filter": {
        "chain": "Kette",
        "region": "Region",
        "searchRegions": "Regionen suchen…",
        "noRegions": "Keine Regionen gefunden"
      },
      "addStoreButton": "Filiale erstellen"
    },
    "dialog": {
      "createTitle": "Filiale erstellen",
      "duplicateTitle": "Filiale duplizieren",
      "deactivateTitle": "Filiale deaktivieren",
      "activateTitle": "Filiale aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "deactivateConsequencesIntro": "Dies wird:",
      "deactivateConsequence1": "Alle Kameras der Filiale deaktivieren",
      "deactivateConsequence2": "Anmeldung für der Filiale zugewiesene Benutzer verhindern",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivateConfirm": "Deaktivieren",
      "activateConfirm": "Aktivieren"
    },
    "form": {
      "legibleName": "Anzeigename",
      "storeName": "Filialname",
      "storeCode": "Filialcode",
      "chainName": "Kette",
      "timeZone": "Zeitzone",
      "copySettings": "Einstellungen aus einer bestehenden Filiale kopieren",
      "selectChain": "Kette auswählen",
      "searchChains": "Ketten suchen…",
      "noChains": "Keine Ketten gefunden",
      "selectTimezone": "Zeitzone auswählen",
      "searchTimezones": "Zeitzonen suchen…",
      "noTimezones": "Keine Zeitzonen gefunden",
      "selectCopyFrom": "Quellfiliale auswählen",
      "searchCopyFrom": "Filialen suchen…",
      "noCopyFrom": "Keine Filialen gefunden",
      "notSet": "Nicht festgelegt",
      "goLiveDate": "Inbetriebnahme",
      "cannotChangeAfterCreation": "Kann nach der Erstellung nicht geändert werden",
      "address": "Adresse",
      "city": "Stadt",
      "state": "Bundesland",
      "zipCode": "PLZ",
      "country": "Land",
      "region": "Region",
      "selectCountry": "Land auswählen",
      "searchCountries": "Länder suchen…",
      "noCountries": "Keine Länder gefunden",
      "selectRegion": "Region auswählen",
      "searchRegions": "Regionen suchen…",
      "noRegions": "Keine Regionen gefunden"
    },
    "cameraCount_one": "{{count}} Gerät",
    "cameraCount_other": "{{count}} Geräte",
    "compare": {
      "title": "Einstellungen vergleichen",
      "onlyDiffs": "Unterschiede",
      "noDifferences": "Keine Unterschiede gefunden",
      "dialog": {
        "title": "Filialeinstellungen vergleichen",
        "description": "Wählen Sie zwei Filialen aus, um deren Einstellungen zu vergleichen.",
        "sourceLabel": "Quellfiliale",
        "targetLabel": "Vergleichen mit",
        "pickStore": "Filiale auswählen…",
        "compare": "Vergleichen"
      }
    },
    "notifications": {
      "created": "Filiale \"{{name}}\" erstellt",
      "updated": "Filiale \"{{name}}\" aktualisiert"
    },
    "info": {
      "wipBanner": "In Arbeit — demnächst verfügbar",
      "fields": {
        "displayName": "Anzeigename",
        "storeName": "Filialname",
        "storeCode": "Filialcode",
        "chain": "Kette",
        "goLiveDate": "Inbetriebnahme",
        "status": "Status",
        "address": "Adresse",
        "city": "Stadt",
        "state": "Bundesland",
        "zipCode": "PLZ",
        "country": "Land",
        "region": "Region",
        "timeZone": "Zeitzone",
        "openTime": "Öffnungszeit",
        "closeTime": "Schließzeit",
        "deviceType": "Gerätetyp",
        "cameras": "Geräte",
        "cameraOnTime": "Kameras an",
        "cameraOffTime": "Kameras aus"
      },
      "cameraCountSummary": "{{active}} aktiv von {{total}}",
      "storeDetails": {
        "title": "Filialdetails"
      },
      "address": {
        "title": "Adresse"
      },
      "hours": {
        "title": "Öffnungszeiten"
      },
      "impactSettings": {
        "title": "Impact-Einstellungen"
      },
      "matchSettings": {
        "title": "Match-Einstellungen"
      },
      "scheduleSettings": {
        "title": "Zeitplan-Einstellungen"
      }
    },
    "operations": {
      "fields": {
        "storeHours": "Öffnungszeiten",
        "cameraHours": "Kamera-Betriebszeiten",
        "priorityLogic": "Priorisierungslogik",
        "sortingLogic": "Sortierlogik",
        "minWorkable": "Minimal bearbeitbar",
        "isPromoOnTop": "Promotionen oben",
        "isAssociatesCanSort": "Mitarbeiter dürfen sortieren",
        "isShowDsdItems": "DSD-Artikel anzeigen",
        "isShowNonWorkable": "Nicht bearbeitbare anzeigen",
        "isHidePog": "POG ausblenden",
        "isDisableIngress": "Ingress deaktivieren",
        "isExcludeFromQueue": "Aus Warteschlange ausschließen",
        "isDiscrepDisableIngress": "Discrep-Ingress deaktivieren",
        "cooldownHours": "Cooldown-Stunden"
      },
      "selectPriorityLogic": "Priorisierungslogik auswählen",
      "selectSortingLogic": "Sortierlogik auswählen",
      "searchOption": "Suchen…",
      "noOption": "Keine Optionen gefunden",
      "notifications": {
        "updated": "Betriebseinstellungen für „{{name}}“ aktualisiert"
      }
    },
    "hardware": {
      "fields": {
        "ssid": "SSID",
        "password": "Passwort",
        "username": "Benutzername",
        "authMode": "Auth-Modus",
        "timeout": "Timeout (ms)",
        "otaVersion": "ESP32-OTA-Version",
        "sc25OtaVersion": "SC25-OTA-Version",
        "sc25OtaComponentVersion": "SC25-OTA-Version ({{cpuType}} / {{firmwareType}})",
        "forceUnfreezeDevices": "Zuweisung für alle Geräte erzwingen",
        "overrideChainVersion": "Kettenversion überschreiben",
        "remoteUrl": "Bild-Empfänger-URL",
        "jpgQuality": "JPEG-Qualität",
        "deploymentInterval": "Bereitstellungsintervall",
        "streamingTime": "Streaming-Zeit (s)",
        "autoWhiteBalance": "Automatischer Weißabgleich"
      },
      "firmwareSection": "Firmware",
      "networkSection": "Netzwerk",
      "selectAuthMode": "Auth-Modus auswählen",
      "selectOtaVersion": "ESP32-OTA-Version auswählen",
      "selectSc25OtaVersion": "SC25-OTA-Version auswählen",
      "forceUnfreezeDevicesHint": "OTA-Konfigurationen einzelner Geräte werden überschrieben",
      "notifications": {
        "updated": "Hardware-Einstellungen für „{{name}}“ aktualisiert"
      }
    },
    "map": {
      "title": "Filialkarte",
      "noMap": "Noch keine Karte für diese Filiale hochgeladen.",
      "uploadButton": "Karte hochladen",
      "uploadSuccess": "Karte erfolgreich hochgeladen",
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern",
      "resetView": "Ansicht zurücksetzen"
    },
    "schedule": {
      "everyday": "Täglicher Zeitplan",
      "exceptions": "Ausnahmen",
      "noExceptions": "Keine Ausnahmen. Der tägliche Zeitplan gilt jeden Tag.",
      "legend": "Legende:",
      "copyEveryday": "Täglichen übernehmen",
      "addPinHint": "Klicken Sie auf die Leiste, um eine Aufnahmezeit hinzuzufügen",
      "algorithmTimed": "{{count}} Bilder/Tag · algorithmisch geplant",
      "capturesPerDay": "{{count}} Bilder/Tag",
      "fields": {
        "images": "Bilder",
        "awakeTime": "Aufwachzeit"
      },
      "strategies": {
        "every_hour": "Stündlich",
        "no_of_images": "N Bilder/Tag",
        "static": "Zeitfenster",
        "strict": "Genaue Zeiten"
      },
      "labels": {
        "model": "Modell",
        "off": "Aus",
        "human": "Mensch",
        "qr": "QR"
      },
      "popover": {
        "window": "Fenster {{range}}",
        "slotAt": "Aufnahme um {{time}}",
        "remove": "Entfernen"
      },
      "exception": {
        "addTitle": "Ausnahme hinzufügen",
        "editTitle": "Ausnahme bearbeiten",
        "subtitle": "Legen Sie fest, wann dieser Zeitplan anstelle des täglichen gilt.",
        "scheduleHeading": "Ausnahme-Zeitplan",
        "name": "Name",
        "tickets": "Tickets",
        "rule": "Regel",
        "ruleInvalid": "Ungültige Regelsyntax",
        "variables": "Verfügbare Variablen"
      },
      "notifications": {
        "updated": "Zeitplan für \"{{name}}\" aktualisiert"
      },
      "mixedLabel": "Gemischt",
      "add": "Hinzufügen"
    },
    "cutOffTimes": {
      "searchPlaceholder": "Cut-Off-Zeiten suchen...",
      "noCutOffTimes": "Keine Cut-Off-Zeiten",
      "everyDay": "Täglich",
      "default": "Standard",
      "localTimeNote": "Zeiten in der Ortszeit der Filiale",
      "useCases": {
        "reporting": "Reporting",
        "impact": "Impact"
      },
      "scopes": {
        "store": "Filiale",
        "chain": "Kette"
      },
      "filter": {
        "useCase": "Anwendungsfall",
        "scope": "Ebene"
      },
      "columns": {
        "id": "ID",
        "cutOffTime": "Uhrzeit",
        "useCase": "Anwendungsfall",
        "dayOfWeek": "Tage",
        "department": "Abteilung",
        "taskType": "Aufgabentyp",
        "isDefault": "Standard",
        "scope": "Gesetzt auf"
      },
      "days": {
        "mon": "Mo",
        "tue": "Di",
        "wed": "Mi",
        "thu": "Do",
        "fri": "Fr",
        "sat": "Sa",
        "sun": "So"
      },
      "addButton": "Cut-Off-Zeit hinzufügen",
      "form": {
        "createTitle": "Cut-Off-Zeit hinzufügen",
        "editTitle": "Cut-Off-Zeit bearbeiten",
        "chainWideWarning": "Gilt für jede Filiale der Kette, sofern eine Filiale sie nicht mit einer eigenen Cut-Off-Zeit überschreibt.",
        "cutOffTime": "Uhrzeit",
        "useCase": "Anwendungsfall",
        "days": "Tage",
        "department": "Abteilung",
        "taskType": "Aufgabentyp",
        "isDefault": "Standard",
        "isDefaultHint": "Als primären Cut-Off für diese Bedingung verwenden",
        "everyDayHint": "keine Auswahl — täglich",
        "notRequired": "nicht erforderlich",
        "validation": {
          "cutOffTimeRequired": "Cut-Off-Zeit wählen",
          "cutOffTimeStep": "Cut-Off-Zeiten in 15-Minuten-Schritten"
        },
        "duplicate": "Für diese Filiale existiert bereits eine Cut-Off-Zeit mit diesen Einstellungen"
      },
      "notifications": {
        "created": "Cut-Off-Zeit hinzugefügt",
        "createFailed": "Cut-Off-Zeit konnte nicht hinzugefügt werden",
        "updated": "Cut-Off-Zeit aktualisiert",
        "updateFailed": "Cut-Off-Zeit konnte nicht aktualisiert werden",
        "deleted": "Cut-Off-Zeit gelöscht",
        "deleteFailed": "Cut-Off-Zeit konnte nicht gelöscht werden"
      },
      "actions": {
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "noChainPermissionHint": "Sie haben keine Berechtigung, kettenweite Cut-Off-Zeiten zu ändern",
        "noStorePermissionHint": "Sie haben keine Berechtigung, die Cut-Off-Zeiten dieser Filiale zu ändern"
      },
      "deleteDialog": {
        "title": "Cut-Off-Zeit löschen?",
        "description": "Der {{useCase}}-Cut-Off um {{time}} wird entfernt. Dies kann nicht rückgängig gemacht werden.",
        "chainWideWarning": "Dies ist eine kettenweite Cut-Off-Zeit. Das Entfernen ändert das Verhalten für jede Filiale der Kette, die keine eigene setzt.",
        "confirm": "Löschen"
      }
    },
    "bulkCreate": {
      "title": "Filialen im Stapel anlegen",
      "sheet": "Tabellenblatt",
      "uploadPrompt": "Tabelle hochladen",
      "uploadHint": "XLSX, XLS oder CSV — die erste Zeile muss Spaltenüberschriften enthalten",
      "selectColumn": "Spalte auswählen",
      "noColumn": "— Keine —",
      "unnamedColumn": "Spalte {{index}}",
      "rowCount": "{{count}} Zeilen",
      "previewNote": "{{shown}} von {{total}} Zeilen angezeigt",
      "validSummary": "{{valid}} gültig · {{invalid}} mit Problemen",
      "rowColumn": "Zeile",
      "errorColumn": "Fehler",
      "creating": "Filialen werden angelegt…",
      "createdCount": "{{count}} angelegt",
      "failedCount": "{{count}} fehlgeschlagen",
      "createButton": "{{count}} Filialen anlegen",
      "downloadFailures": "Fehler herunterladen",
      "back": "Zurück",
      "errors": {
        "noSheets": "Keine Tabellenblätter in der Datei gefunden",
        "parseFailed": "Datei konnte nicht gelesen werden",
        "createFailed": "Anlegen fehlgeschlagen",
        "missing": "{{field}} ist erforderlich",
        "unknownChain": "Kette ‘{{chain}}’ nicht gefunden",
        "dupCode": "Doppelter Filialcode ‘{{code}}’",
        "requiredUnmapped": "Ordne alle Pflichtfelder (*) zu, um fortzufahren",
        "badTime": "{{field}} „{{raw}}\" ist keine gültige Zeit",
        "timeOrder": "Öffnungszeit darf nicht nach der Schließzeit liegen",
        "hoursFailed": "Filiale konnte zum Setzen der Öffnungszeiten nicht gelesen werden",
        "hoursUnavailable": "Öffnungszeiten übersprungen — Betriebsdaten der Filiale nicht verfügbar",
        "patchFailed": "Folge-Update fehlgeschlagen",
        "cameraTimeOrder": "Kamera-Einschaltzeit darf nicht nach der Ausschaltzeit liegen"
      },
      "mode": {
        "column": "Spalte",
        "constant": "Wert",
        "computed": "Berechnet"
      },
      "computedHint": "Abgeleitet: chain_storeCode",
      "valuePlaceholder": "Wert eingeben",
      "next": "Weiter",
      "selectedSummary": "{{selected}} von {{total}} ausgewählt",
      "existsSummary": "{{count}} bereits vorhanden",
      "invalidSummary": "{{count}} ungültig",
      "selectAll": "Alle auswählen",
      "searchColumns": "Spalten suchen…",
      "noColumns": "Keine Spalten gefunden",
      "appendCode": "+ (Filialcode)",
      "selectSheet": "Tabellenblatt auswählen",
      "searchSheets": "Tabellenblätter suchen…",
      "noSheetsFound": "Keine Tabellenblätter gefunden",
      "includeAddress": "Adresse einschließen",
      "active": "Aktiv",
      "includeHours": "Öffnungs- und Kamerazeiten einschließen",
      "patchFailedCount": "{{count}} Folge-Updates fehlgeschlagen",
      "patchIssue": "Filiale angelegt, Folge-Update fehlgeschlagen: {{error}}",
      "skippedCount": "{{count}} übersprungen",
      "skippedExists": "Übersprungen — Filiale existiert bereits"
    },
    "tools": {
      "menuLabel": "Werkzeuge",
      "bulkCreate": "Filialen im Stapel anlegen"
    }
  },
  "storeHealth": {
    "refreshAll": "Alle aktualisieren",
    "refreshPanel": "{{panel}} aktualisieren",
    "lastChecked": "Zuletzt geprüft {{time}}",
    "retry": "Erneut versuchen",
    "panelError": "Dieses Panel konnte nicht geladen werden.",
    "noReferenceStore": "Für diese Kette ist keine Referenzfiliale konfiguriert, daher gibt es nichts zu vergleichen.",
    "searchPlaceholder": "Tabelle und Einstellung suchen…",
    "clearSearch": "Suche zurücksetzen",
    "onlyDifferences": "Nur Abweichungen ({{count}})",
    "noRows": "Nichts anzuzeigen.",
    "status": {
      "pass": "Bestanden",
      "warn": "Warnung",
      "fail": "Fehler",
      "info": "Info",
      "skip": "Übersprungen"
    },
    "origin": {
      "canon": "Kanon",
      "reference": "Referenz",
      "store-only": "Nur Filiale"
    },
    "columns": {
      "check": "Prüfung",
      "status": "Status",
      "value": "Wert",
      "threshold": "Schwellenwert",
      "setting": "Einstellung",
      "expected": "Erwartet",
      "storeValue": "Filialwert"
    },
    "panels": {
      "identity": {
        "title": "Identität & Einrichtung",
        "description": "Physische Einrichtung und Stammdaten der Filiale."
      },
      "cameras": {
        "title": "Kameras & Vorlagen",
        "description": "Kamera-Streaming, Vorlagenabweichungen und offene Scan-in-Aufgaben."
      },
      "planograms": {
        "title": "Planogramme & Katalog",
        "description": "Planogrammabdeckung und Katalogqualität."
      },
      "imports": {
        "title": "Importe",
        "description": "Eingehende Kundendaten und Aktualität der Regalkapazität."
      },
      "settingsDiff": {
        "title": "Einstellungs- & Konfigurationsvergleich",
        "description": "Verglichen mit <store/>. Diagnostisch — kein Bestanden/Fehler-Urteil.",
        "descriptionGeneric": "Verglichen mit der Referenzfiliale der Kette. Diagnostisch — kein Bestanden/Fehler-Urteil."
      }
    }
  },
  "dataTable": {
    "noResults": "Keine Ergebnisse.",
    "showing": "Zeige {{from}}-{{to}} von {{total}}",
    "noResultsCount": "Keine Ergebnisse",
    "rows": "{{count}} Zeilen",
    "export": "Exportieren",
    "resetColumns": "Auf Standard zurücksetzen",
    "allTimesIn": "Alle Zeiten in <tz/>",
    "presets": {
      "label": "Voreinstellungen",
      "empty": "Keine gespeicherten Voreinstellungen",
      "save": "Aktuelle Filter speichern…",
      "saveTitle": "Filter-Voreinstellung speichern",
      "saveDescription": "Speichert aktuelle Filter, Suche und Sortierung unter einem Namen, den du mit einem Klick erneut anwenden kannst. Die Seitengröße wird nicht gespeichert.",
      "nameLabel": "Name der Voreinstellung",
      "namePlaceholder": "z. B. Filialen UK noch nicht live",
      "overwrite": "Überschreiben",
      "overwriteHint": "Eine Voreinstellung mit diesem Namen existiert bereits — beim Speichern wird sie ersetzt.",
      "delete": "Voreinstellung „{{name}}“ löschen",
      "clear": "Voreinstellung entfernen",
      "saved": "Voreinstellung „{{name}}“ gespeichert",
      "deleted": "Voreinstellung „{{name}}“ gelöscht"
    }
  },
  "common": {
    "loading": "Laden…",
    "useValue": "\"{{value}}\" verwenden",
    "noResults": "Keine Ergebnisse gefunden",
    "copiedToClipboard": "In die Zwischenablage kopiert:",
    "active": "Aktiv",
    "workInProgress": "In Arbeit…",
    "createdAt": "Erstellt",
    "updatedAt": "Aktualisiert",
    "clear": "Löschen",
    "fileTypeNotAccepted": "Nur {{types}}-Dateien werden akzeptiert"
  },
  "passkeys": {
    "title": "Passkeys",
    "description": "Mit Passkeys meldest du dich per Fingerabdruck, Gesicht oder Geräte-PIN an – ohne Passwort.",
    "empty": "Noch keine Passkeys. Füge einen hinzu, um dich künftig schneller anzumelden.",
    "namePlaceholder": "Passkey-Name (z. B. MacBook Touch ID)",
    "add": "Passkey hinzufügen",
    "adding": "Wird eingerichtet…",
    "registered": "Passkey hinzugefügt",
    "revoke": "Widerrufen",
    "revoked": "Passkey widerrufen",
    "added": "Hinzugefügt am {{date}}",
    "lastUsed": "zuletzt verwendet {{date}}",
    "neverUsed": "nie verwendet",
    "deviceType": {
      "multi_device": "Synchronisiert",
      "single_device": "Dieses Gerät"
    },
    "error": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    "revokeDialog": {
      "title": "Passkey widerrufen",
      "prompt": "Möchten Sie wirklich widerrufen",
      "warning": "Dieser Passkey kann nicht mehr zur Anmeldung verwendet werden. Diese Aktion kann nicht rückgängig gemacht werden.",
      "confirm": "Widerrufen"
    }
  },
  "settings": {
    "title": "Einstellungen",
    "columns": {
      "name": "Name",
      "key": "Schlüssel",
      "setting": "Einstellung"
    },
    "info": {
      "title": "Einstellungsinformationen",
      "showMore": "Mehr anzeigen",
      "showLess": "Weniger anzeigen",
      "fields": {
        "key": "Schlüssel",
        "name": "Name",
        "description": "Beschreibung",
        "noDescription": "Keine Beschreibung",
        "group": "Gruppe",
        "type": "Typ",
        "defaultValue": "Standardwert",
        "chainOverrides": "Ketten-Overrides",
        "storeOverrides": "Filial-Overrides"
      }
    },
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "key": "Schlüssel",
        "groupName": "Gruppe",
        "fieldType": "Typ",
        "defaultValue": "Standard",
        "chainOverrides": "Ketten-Overrides",
        "storeOverrides": "Filial-Overrides",
        "value": "Wert",
        "source": "Quelle",
        "status": "Status"
      },
      "filter": {
        "overridesOnly": "Überschreibungen",
        "group": "Gruppe",
        "searchGroups": "Gruppen suchen…",
        "noGroups": "Keine Gruppen gefunden",
        "chainOverrides": "Ketten-Überschreibungen",
        "storeOverrides": "Filial-Überschreibungen"
      },
      "searchPlaceholder": "Einstellungen suchen...",
      "actions": {
        "edit": "Bearbeiten",
        "restoreDefault": "Standard wiederherstellen"
      },
      "editDialog": {
        "title": "Einstellung bearbeiten",
        "nameLabel": "Name",
        "keyLabel": "Schlüssel",
        "defaultValueLabel": "Standardwert",
        "valueLabel": "Wert",
        "selectPlaceholder": "Wert auswählen",
        "selectSearchPlaceholder": "Werte suchen…",
        "noValues": "Keine Werte",
        "invalidNumber": "Muss eine gültige Zahl sein",
        "cancel": "Abbrechen",
        "save": "Speichern"
      },
      "restoreDialog": {
        "title": "Standard wiederherstellen",
        "description": "Möchten Sie \"{{name}}\" wirklich auf den Standardwert zurücksetzen?",
        "cancel": "Abbrechen",
        "confirm": "Wiederherstellen"
      },
      "toast": {
        "updated": "Einstellung \"{{name}}\" aktualisiert",
        "updateError": "Einstellung konnte nicht aktualisiert werden",
        "restored": "Einstellung \"{{name}}\" auf Standard zurückgesetzt",
        "restoreError": "Einstellung konnte nicht wiederhergestellt werden"
      },
      "jsonPreview": {
        "description": "Diese Vorschau ist zur besseren Lesbarkeit formatiert. Der Originalwert wird minimiert gespeichert.",
        "copy": "Kopieren"
      }
    },
    "chains": {
      "columns": {
        "id": "ID",
        "name": "Kette",
        "value": "Wert",
        "status": "Status"
      },
      "searchPlaceholder": "Ketten suchen…"
    },
    "stores": {
      "columns": {
        "id": "ID",
        "store": "Filiale",
        "chain": "Kette",
        "value": "Wert",
        "status": "Status"
      },
      "searchPlaceholder": "Filialen suchen…"
    },
    "status": {
      "override": "override",
      "default": "standard",
      "store": "filiale",
      "chain": "kette"
    }
  },
  "imports": {
    "importData": "Daten importieren",
    "importCsv": "CSV importieren",
    "searchPlaceholder": "Importe suchen…",
    "columns": {
      "id": "ID",
      "publicId": "Öffentliche ID",
      "timestamp": "Erstellt",
      "type": "Typ",
      "createdBy": "Hochgeladen von",
      "store": "Filiale",
      "source": "Quelle",
      "processingTime": "Verarbeitungszeit",
      "status": "Status",
      "validationTime": "Validierungszeit",
      "queueingTime": "Wartezeit",
      "itemsFound": "Gefundene Elemente",
      "productsFound": "Gefundene Produkte",
      "productsCreated": "Erstellte Produkte",
      "productsUpdated": "Aktualisierte Produkte",
      "productsZeroed": "Auf Null gesetzte Produkte",
      "storeCode": "Filialcode",
      "items": "Elemente",
      "createdAt": "Erstellt"
    },
    "actions": {
      "retrigger": "Erneut auslösen",
      "downloadJson": "JSON-Datei herunterladen",
      "downloadCsv": "CSV-Datei herunterladen",
      "copyRawJson": "Rohen JSON-Pfad kopieren",
      "copyRawCsv": "Rohen CSV-Pfad kopieren",
      "downloadError": "Download-Link konnte nicht erstellt werden"
    },
    "retrigger": {
      "title": "Import erneut auslösen",
      "prompt": "Diesen Import erneut ausführen. Nützlich nach einem Fehler.",
      "confirm": "Erneut auslösen",
      "success": "Import #{{id}} zum erneuten Auslösen eingereiht",
      "errorTitle": "Import konnte nicht erneut ausgelöst werden",
      "errors": {
        "missingContent": "Import #{{id}} hat keine vorbereitete JSON-Datei und kann nicht erneut ausgelöst werden.",
        "notFound": "Import #{{id}} wurde nicht gefunden."
      },
      "includeSubsequent": {
        "label": "Folgende Importe ebenfalls erneut auslösen",
        "hint": "Spätere Importe desselben Typs für diese Filiale werden der Reihe nach erneut ausgeführt."
      }
    },
    "csv": {
      "title": "CSV importieren",
      "typeLabel": "Importtyp",
      "typePlaceholder": "Importtyp auswählen…",
      "types": {
        "metadata": "Metadaten",
        "boh": "Lagerbestand",
        "sales": "Verkäufe",
        "pricing": "Preise"
      },
      "fileLabel": "CSV-Datei",
      "fileDropTitle": "CSV-Datei ablegen oder klicken zum Hochladen",
      "overrideStoreCode": "Filialcode überschreiben",
      "uploadingPercent": "Wird hochgeladen… {{percent}}%",
      "processing": "Zeilen werden konvertiert…",
      "upload": "Hochladen",
      "success": "Import #{{id}} mit {{count}} Einträgen erstellt",
      "errorTitle": "Diese Datei konnte nicht importiert werden",
      "moreErrors": "…und {{count}} weitere"
    },
    "wizard": {
      "title": "Daten importieren",
      "submitButton": "Import absenden",
      "submittedSuccess": "Import erfolgreich übermittelt",
      "inactiveTransformation": {
        "title": "Diese Transformation ist deaktiviert",
        "hint": "Du kannst den Import trotzdem absenden, aber Konsistenz und Zuverlässigkeit der importierten Daten sind nicht garantiert."
      },
      "steps": {
        "scope": "Bereich",
        "transformation": "Transformation",
        "upload": "Hochladen",
        "validate": "Validieren",
        "preview": "Vorschau"
      },
      "scope": {
        "selectChain": "Kette auswählen…",
        "searchChains": "Ketten suchen…",
        "noChains": "Keine Ketten gefunden",
        "selectStore": "Filiale auswählen (optional)…",
        "searchStores": "Filialen suchen…",
        "noStores": "Keine Filialen gefunden"
      },
      "transformation": {
        "select": "Transformation auswählen…",
        "search": "Transformationen suchen…",
        "empty": "Keine Transformationen gefunden",
        "filesToPrepare": "Vorzubereitende Dateien"
      },
      "upload": {
        "startingSession": "Importsitzung wird gestartet…",
        "uploadingPercent": "Wird hochgeladen… {{percent}}%",
        "processing": "Verarbeitung…",
        "dropFile": "Datei ablegen oder klicken zum Hochladen ({{fileType}})"
      },
      "validate": {
        "validating": "Dateien werden validiert…",
        "errorsTitle": "Validierungsfehler gefunden",
        "errorsCount": "{{errors}} Fehler in {{files}} Dateien",
        "errorColumn": "(Spalte: {{column}})",
        "errorRow": "in Zeile {{location}}"
      },
      "preview": {
        "submitting": "Import wird übermittelt…",
        "preparing": "Importanfragen werden vorbereitet…",
        "preparingProgress": "Filiale {{current}} von {{total}} wird vorbereitet…",
        "submittingProgress": "Importanfrage {{current}} von {{total}} wird erstellt…",
        "filesProcessed": "Verarbeitete Dateien",
        "validFiles": "Gültige Dateien",
        "totalRecords": "Datensätze insgesamt",
        "storesAffected": "Betroffene Filialen",
        "estDuration": "Gesch. Dauer",
        "storeCodes": "Verarbeitete Filialcodes",
        "importRequests": "Importanfragen",
        "itemsCount": "{{count}} Elemente"
      }
    }
  },
  "tabs": {
    "info": "Info",
    "health": "Zustand",
    "edit": "Bearbeiten",
    "permissions": "Berechtigungen",
    "boPermissions": "BO-Berechtigungen",
    "users": "Benutzer",
    "chains": "Ketten",
    "stores": "Filialen",
    "map": "Karte",
    "settings": "Einstellungen",
    "operations": "Betrieb",
    "schedule": "Zeitplan",
    "cutOffTimes": "Cut-Off-Zeiten",
    "devices": "Geräte",
    "hardware": "Hardware",
    "imports": "Importe",
    "security": "Sicherheit",
    "activityLog": "Aktivität",
    "usage": "Nutzung"
  },
  "profile": {
    "title": "Mein Profil",
    "edit": {
      "wip": "Die Bearbeitung deines Profils ist noch nicht verfügbar."
    },
    "security": {
      "sso": {
        "title": "Single-Sign-On-Konto",
        "description": "Sie melden sich über den Identitätsanbieter Ihrer Organisation an (SSO). Passwort, Passkeys und Zwei-Faktor-Authentifizierung werden dort verwaltet und können hier nicht eingerichtet werden."
      },
      "password": {
        "title": "Passwort",
        "description": "Ändere das Passwort, mit dem du dich anmeldest.",
        "current": "Aktuelles Passwort",
        "new": "Neues Passwort",
        "confirm": "Neues Passwort bestätigen",
        "submit": "Passwort ändern",
        "submitting": "Wird geändert…",
        "success": "Passwort geändert",
        "required": "Dieses Feld ist erforderlich",
        "tooShort": "Mindestens 8 Zeichen verwenden",
        "mismatch": "Die neuen Passwörter stimmen nicht überein",
        "invalid": "Dein aktuelles Passwort ist falsch",
        "error": "Passwort konnte nicht geändert werden. Bitte versuche es erneut."
      },
      "mfa": {
        "title": "Zwei-Faktor-Authentifizierung",
        "description": "Füge mit einer Authenticator-App eine zusätzliche Sicherheitsebene hinzu.",
        "statusLabel": "Authenticator-App",
        "enabledStatus": "Aktiviert",
        "setup": "Zwei-Faktor einrichten",
        "disable": "Deaktivieren",
        "setupTitle": "Zwei-Faktor-Authentifizierung einrichten",
        "setupDescription": "Scanne den QR-Code mit deiner Authenticator-App und gib dann den 6-stelligen Code zur Bestätigung ein.",
        "qrAlt": "Zwei-Faktor-QR-Code",
        "secretLabel": "Oder gib diesen Einrichtungsschlüssel manuell ein",
        "codeLabel": "Bestätigungscode",
        "enable": "Aktivieren",
        "enabled": "Zwei-Faktor-Authentifizierung aktiviert",
        "invalidCode": "Der Code stimmt nicht. Bitte versuche es erneut.",
        "generateError": "Einrichtung konnte nicht gestartet werden. Bitte versuche es erneut.",
        "disableTitle": "Zwei-Faktor-Authentifizierung deaktivieren",
        "disableConfirm": "Für dein Konto wird bei der Anmeldung kein Bestätigungscode mehr benötigt. Bist du sicher?",
        "disabled": "Zwei-Faktor-Authentifizierung deaktiviert",
        "disableError": "Zwei-Faktor konnte nicht deaktiviert werden. Bitte versuche es erneut."
      }
    },
    "settings": {
      "appearance": {
        "title": "Darstellung",
        "description": "Design, Sprache und Datumsformat für dieses Gerät."
      },
      "theme": {
        "label": "Design"
      },
      "accent": {
        "label": "Akzentfarbe",
        "options": {
          "green": "Grün",
          "red": "Rot",
          "blue": "Blau"
        }
      },
      "language": {
        "label": "Sprache",
        "hint": "Gilt nur für Beschriftungen und Meldungen — das Datumsformat wird dadurch nicht geändert."
      },
      "dateFormat": {
        "label": "Datumsformat",
        "hint": "Gilt für alle Datumsangaben in der App. „System“ übernimmt die Regionseinstellungen deines Betriebssystems.",
        "options": {
          "system": "System",
          "dmy": "Tag zuerst",
          "mdy": "Monat zuerst",
          "iso": "Jahr zuerst (ISO)"
        }
      },
      "tables": {
        "title": "Tabellen",
        "description": "Standardwerte für Listen- und Tabellenansichten."
      },
      "itemsPerPage": {
        "label": "Einträge pro Seite",
        "hint": "Wird beim nächsten Öffnen jeder Tabelle angewendet."
      },
      "integrations": {
        "title": "Integrationen",
        "description": "Verbinde deine Konten mit Focal."
      },
      "slack": {
        "label": "Slack-Benutzername",
        "placeholder": "@dein.name",
        "hint": "In deinem Konto gespeichert.",
        "save": "Speichern",
        "saved": "Slack-Benutzername gespeichert",
        "saveError": "Slack-Benutzername konnte nicht gespeichert werden. Bitte versuche es erneut."
      },
      "advanced": {
        "title": "Erweitert",
        "description": "Diagnose- und Zurücksetzen-Optionen."
      },
      "diagnostics": {
        "title": "Diagnose",
        "description": "Entwickler- und QA-Tools für dieses Gerät."
      },
      "httpErrorToasts": {
        "label": "HTTP-Fehler-Toasts anzeigen",
        "hint": "Zeigt bei jedem fehlgeschlagenen API-Aufruf (422, 5xx oder Netzwerkfehler) einen Toast mit Anfrage- und Antwortdetails an. Nützlich für QA und Debugging."
      },
      "reset": {
        "title": "Einstellungen zurücksetzen",
        "description": "Alle gerätelokalen Einstellungen auf die Standardwerte zurücksetzen.",
        "button": "Lokale Einstellungen zurücksetzen",
        "toast": "Einstellungen zurückgesetzt",
        "dialog": {
          "title": "Lokale Einstellungen zurücksetzen?",
          "description": "Dadurch werden Design, Sprache, Tabellenlayouts und andere gerätelokale Einstellungen gelöscht und die App neu geladen. Dein Konto und deine Anmeldung sind nicht betroffen.",
          "cancel": "Abbrechen",
          "confirm": "Zurücksetzen"
        }
      }
    }
  },
  "activity": {
    "searchPlaceholder": "Aktivität durchsuchen...",
    "empty": "Keine Aktivität gefunden",
    "wipBanner": "In Arbeit — Daten sind simuliert",
    "filter": {
      "timeRange": "Zeitraum",
      "onlyChain": "Nur Kette"
    }
  },
  "buttons": {
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "save": "Speichern",
    "discard": "Verwerfen",
    "stayOnPage": "Auf Seite bleiben",
    "discardAndLeave": "Verwerfen & verlassen",
    "schedule": "Planen",
    "submitForApproval": "Zur Genehmigung einreichen",
    "back": "Zurück",
    "next": "Weiter",
    "validate": "Validieren",
    "edit": "Bearbeiten",
    "done": "Fertig",
    "close": "Schließen"
  },
  "unsavedChanges": {
    "title": "Nicht gespeicherte Änderungen",
    "description": "Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen? Ihre Änderungen gehen verloren."
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "empty": "Keine Benachrichtigungen",
    "wipBanner": "In Arbeit — Daten sind simuliert",
    "markAllRead": "Alle als gelesen markieren",
    "markRead": "Als gelesen markieren",
    "dismiss": "Verwerfen",
    "actions": {
      "review": "Überprüfen",
      "approve": "Genehmigen"
    },
    "mock": {
      "importFailed": {
        "title": "Import fehlgeschlagen für Lidl DE #4012",
        "description": "Produktkatalog-Import fehlgeschlagen wegen fehlender Pflichtspalten. Manuelle Überprüfung erforderlich."
      },
      "settingApproval": {
        "title": "Einstellungsänderung erfordert Genehmigung",
        "description": "\"camera_resolution\" wurde bei Aldi Süd — Berlin Mitte geändert. Wartet auf Ihre Genehmigung."
      },
      "importComplete": {
        "title": "Import erfolgreich abgeschlossen",
        "description": "Planogramm-Import für Carrefour FR abgeschlossen — 847 Artikel verarbeitet."
      },
      "storeOffline": {
        "title": "Kameras im Store offline",
        "description": "3 Kameras bei Tesco UK — Manchester Central sind seit über 2 Stunden offline."
      },
      "userCreated": {
        "title": "Neuer Benutzer erstellt",
        "description": "Benutzer \"m.schmidt@lidl.com\" wurde erstellt und Lidl DE zugewiesen."
      },
      "settingUpdated": {
        "title": "Einstellung aktualisiert",
        "description": "Standardwert für \"detection_threshold\" von 0,7 auf 0,75 geändert."
      }
    }
  },
  "header": {
    "commands": "Befehle..."
  },
  "approvals": {
    "title": "Genehmigungen",
    "tabs": {
      "pending": "Ausstehend",
      "resolved": "Erledigt"
    },
    "status": {
      "pending": "Ausstehend",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt",
      "executed": "Ausgeführt",
      "failed": "Fehlgeschlagen"
    },
    "actions": {
      "approve": "Genehmigen",
      "reject": "Ablehnen"
    },
    "actionTypes": {
      "create-chain": "Chain erstellen"
    },
    "scheduleForLater": "Für später planen",
    "requestedExecutionTime": "Gewünschter Ausführungszeitpunkt (nach Genehmigung)",
    "scheduledFor": "Geplant für {{time}}",
    "scheduledForFooter": "Geplant für: {{time}}",
    "requestedBy": "Angefragt von {{name}}",
    "resolvedBy": "{{action}} von {{name}}",
    "rejectionReason": "Grund (optional)",
    "rejectDescription": "Geben Sie optional einen Grund für die Ablehnung an.",
    "submitDialog": {
      "title": "Zur Genehmigung einreichen",
      "titleWithAction": "\"{{action}}\" zur Genehmigung einreichen",
      "description": "Überprüfen Sie die folgenden Details. Ein Admin muss diese Aktion genehmigen, bevor sie ausgeführt wird.",
      "scheduleHint": "Leer lassen, um sofort nach Genehmigung auszuführen.",
      "messagePlaceholder": "Nachricht an den Genehmiger (optional)"
    },
    "clearSchedule": "Löschen",
    "noActions": "Keine ausstehenden Aktionen",
    "wipBanner": "In Arbeit — Daten sind simuliert",
    "noResolvedActions": "Keine erledigten Aktionen",
    "notifications": {
      "scheduled": "\"{{name}}\" wurde geplant",
      "submittedForApproval": "\"{{name}}\" zur Genehmigung eingereicht"
    }
  },
  "commandPalette": {
    "placeholder": "Befehl eingeben oder suchen...",
    "empty": "Keine Ergebnisse gefunden.",
    "pages": "Seiten",
    "settings": "Einstellungen",
    "commands": "Befehle",
    "profile": "Profil",
    "myProfile": "Mein Profil",
    "debug": "Debuggen",
    "logout": "Abmelden",
    "back": "Zurück",
    "footer": {
      "navigate": "Navigieren",
      "select": "Auswählen",
      "goBack": "Zurück",
      "close": "Schließen"
    },
    "createChain": "Kette erstellen",
    "createStore": "Filiale erstellen",
    "createUser": "Benutzer erstellen",
    "createVendor": "Anbieter erstellen",
    "createTransformation": "Transformation erstellen",
    "importData": "Daten importieren",
    "compareChainSettings": "Ketteneinstellungen vergleichen",
    "compareStoreSettings": "Filialeinstellungen vergleichen",
    "refreshView": "Aktuelle Ansicht aktualisieren",
    "featureFlags": "Feature-Flags",
    "telemetry": "API-Telemetrie",
    "showcase": "Komponentenübersicht",
    "flagOn": "an",
    "flagOff": "aus",
    "telemetryClearAll": "Alle löschen",
    "telemetryEmpty": "Noch keine Anfragen aufgezeichnet.",
    "theme": {
      "title": "Design ändern",
      "placeholder": "Design auswählen...",
      "light": "Hell",
      "dark": "Dunkel",
      "system": "System"
    },
    "accent": {
      "title": "Akzentfarbe ändern",
      "placeholder": "Akzentfarbe auswählen..."
    },
    "language": {
      "title": "Sprache ändern",
      "placeholder": "Sprache auswählen..."
    },
    "createOctoRule": "Octo-Regel erstellen",
    "createFirmwareVersion": "Firmware-Version erstellen"
  },
  "octoRules": {
    "title": "Octo-Regeln",
    "unnamed": "Regel #{{id}}",
    "unnamedShort": "Unbenannt",
    "scopeGlobal": "Global",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "scope": "Geltungsbereich",
        "stage": "Phase",
        "outcome": "Ergebnis",
        "priority": "Priorität",
        "createdAt": "Erstellt",
        "status": "Status"
      },
      "searchPlaceholder": "Regeln suchen…",
      "filter": {
        "chain": "Kette",
        "store": "Filiale",
        "stage": "Phase",
        "searchStages": "Phasen suchen…",
        "noStages": "Keine Phasen gefunden"
      },
      "actions": {
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren"
      },
      "addRuleButton": "Regel erstellen"
    },
    "stage": {
      "creation": "Erstellung",
      "visibility": "Sichtbarkeit",
      "workability": "Bearbeitbarkeit"
    },
    "outcome": {
      "allow": "Erlauben",
      "deny": "Verweigern"
    },
    "fields": {
      "name": "Name",
      "description": "Beschreibung",
      "scope": "Geltungsbereich",
      "stage": "Phase",
      "outcome": "Ergebnis",
      "priority": "Priorität",
      "predicate": "Regel",
      "tickets": "Tickets",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "status": "Aktiv",
      "createdAt": "Erstellt",
      "updatedAt": "Aktualisiert"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "edit": "Bearbeiten",
        "activity": "Aktivität"
      }
    },
    "edit": {
      "updated": "Regel „{{name}}“ aktualisiert",
      "predicateInvalid": "Ungültiger CEL-Ausdruck",
      "predicateUnknownProperty": "Unbekannte Eigenschaft",
      "variables": "Variablen",
      "allowedValues": "Zulässige Werte",
      "predicateInvalidValue": "Ungültiger Wert",
      "predicateDecimalExpected": "Dezimalwert erwartet",
      "predicateRuntimeTypeError": "Schlägt bei der Auswertung fehl",
      "predicateObjectNotValue": "Objekt, kein Wert",
      "availableFields": "Verfügbare Felder",
      "fields": "{{variable}}-Felder"
    },
    "dialog": {
      "activateTitle": "Regel aktivieren",
      "deactivateTitle": "Regel deaktivieren",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "activateConfirm": "Aktivieren",
      "deactivateConfirm": "Deaktivieren",
      "deactivateWarning": "Diese Regel wird von Octo nicht mehr angewendet, solange sie inaktiv ist.",
      "createTitle": "Regel erstellen",
      "created": "Regel „{{name}}“ erstellt"
    },
    "form": {
      "chain": "Kette",
      "store": "Filiale",
      "scopeLabel": "Geltungsbereich",
      "selectChain": "Kette auswählen…",
      "selectStore": "Filiale auswählen…"
    },
    "tools": {
      "menuLabel": "Werkzeuge",
      "evaluate": "Regeln auswerten"
    },
    "evaluate": {
      "title": "Regeln auswerten",
      "contextTitle": "Auswertungskontext",
      "contextHint": "Aufgabentyp wählen, um die Kette auszuführen. Produkt und Zeitpunkt ergänzen, um dagegen auszuwerten.",
      "taskType": "Aufgabentyp",
      "selectTaskType": "Aufgabentyp wählen…",
      "searchTaskTypes": "Aufgabentypen suchen…",
      "noTaskTypes": "Keine Aufgabentypen gefunden",
      "evaluatedAt": "Aktuelles Datum & Uhrzeit",
      "product": {
        "upc": "UPC",
        "itemNumber": "Artikelnummer",
        "upcPlaceholder": "Produkt-UPC",
        "itemNumberPlaceholder": "Artikelnummer"
      },
      "timezoneHint": "Zeiten gelten als Ortszeit der Filiale ({{timezone}}). Leer lassen für jetzt.",
      "timezoneHintGeneric": "Zeiten gelten als Ortszeit der Filiale. Leer lassen für jetzt.",
      "pickStore": "Filiale wählen, um die durchlaufenen Regeln zu sehen.",
      "running": "Wird ausgewertet…",
      "failed": "Auswertung fehlgeschlagen",
      "noRules": "Für diese Filiale und Phase gelten keine Regeln.",
      "runButton": "Auswerten",
      "stoppedHere": "Auswertung endete hier",
      "priorityLabel": "Priorität {{priority}}",
      "noPredicate": "Kein Prädikat — gilt immer",
      "outOfDateRange": "Außerhalb des Start-/Endzeitraums, wird aber trotzdem ausgewertet — die Engine ignoriert diese Daten.",
      "outcomeTitle": "Ergebnis",
      "outcomeNone": "Unbestimmt",
      "scope": {
        "global": "Global",
        "chain": "Kette",
        "store": "Filiale"
      },
      "evaluation": {
        "matched": "Zutreffend",
        "notMatched": "Kein Treffer",
        "fallback": "Rückfall",
        "skippedInactive": "Inaktiv",
        "notReached": "Nicht erreicht",
        "error": "Fehler",
        "notEvaluated": "Nicht ausgewertet"
      },
      "reason": {
        "ruleMatched": "Entschieden durch „{{rule}}\" — die erste Regel mit zutreffendem Prädikat.",
        "fallbackRule": "Entschieden durch „{{rule}}\" — eine Regel ohne Prädikat, gilt also immer.",
        "implicitFallback": "Keine Regel traf zu. Die Engine fällt auf Ablehnen zurück.",
        "compileError": "Die Regeln dieser Phase konnten nicht kompiliert werden, keine wurde ausgeführt.",
        "evaluationError": "Die Auswertung brach ab, es wurde keine Entscheidung getroffen.",
        "noRules": "Keine aktiven Regeln für diese Filiale und Phase — die Engine greift nicht ein.",
        "notEvaluated": "Noch nicht ausgewertet. Aufgabentyp wählen und „Auswerten\" drücken."
      },
      "effect": {
        "creation": {
          "allow": "Die Aufgabe würde erstellt.",
          "deny": "Die Aufgabe würde unterdrückt und nie erstellt."
        },
        "visibility": {
          "allow": "Die Aufgabe wäre in der Filiale sichtbar.",
          "deny": "Die Aufgabe wäre in der Filiale ausgeblendet."
        },
        "workability": {
          "allow": "Die Aufgabe wäre bearbeitbar.",
          "deny": "Die Aufgabe wäre nicht bearbeitbar."
        }
      },
      "debug": {
        "compiledRule": "Kompilierte Regelkette",
        "boundContext": "Gebundener Kontext",
        "empty": "Leer"
      }
    }
  },
  "devices": {
    "title": "Geräte",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "store": "Filiale",
        "chain": "Kette",
        "createdAt": "Erstellt",
        "lastImage": "Letztes Bild",
        "lastStatus": "Letzter Status",
        "status": "Status"
      },
      "searchPlaceholder": "Geräte suchen...",
      "filter": {
        "chain": "Kette",
        "store": "Filiale"
      }
    }
  },
  "firmware": {
    "title": "Firmware",
    "list": {
      "columns": {
        "id": "ID",
        "version": "Version",
        "versionNum": "Build",
        "deviceType": "Gerät",
        "cpuType": "CPU",
        "firmwareType": "Firmware",
        "production": "Produktion",
        "createdAt": "Erstellt",
        "status": "Status"
      },
      "searchPlaceholder": "Versionen suchen...",
      "filter": {
        "deviceType": "Gerätetyp",
        "searchDeviceTypes": "Gerätetypen suchen…",
        "noDeviceTypes": "Keine Gerätetypen gefunden",
        "cpuType": "CPU-Typ",
        "searchCpuTypes": "CPU-Typen suchen…",
        "noCpuTypes": "Keine CPU-Typen gefunden",
        "production": "Produktion"
      },
      "addButton": "Version erstellen"
    },
    "fields": {
      "versionStr": "Version",
      "versionNum": "Build-Nummer",
      "deviceType": "Gerätetyp",
      "cpuType": "CPU-Typ",
      "fileUri": "Datei-URI",
      "md5": "MD5",
      "changeLog": "Änderungsprotokoll",
      "createdAt": "Erstellt",
      "updatedAt": "Aktualisiert",
      "file": "Firmware-Datei"
    },
    "production": {
      "ready": "produktiv",
      "draft": "Entwurf"
    },
    "actions": {
      "activate": "Aktivieren",
      "deactivate": "Deaktivieren",
      "markProduction": "Als produktiv markieren",
      "unmarkProduction": "Produktiv-Markierung entfernen"
    },
    "dialog": {
      "activateTitle": "Version aktivieren",
      "deactivateTitle": "Version deaktivieren",
      "activatePrompt": "Möchten Sie wirklich aktivieren",
      "deactivatePrompt": "Möchten Sie wirklich deaktivieren",
      "deactivateWarning": "Geräte erhalten diese Firmware nicht mehr, solange sie inaktiv ist.",
      "activateConfirm": "Aktivieren",
      "deactivateConfirm": "Deaktivieren",
      "markProductionTitle": "Als produktiv markieren",
      "unmarkProductionTitle": "Produktiv-Markierung entfernen",
      "markProductionPrompt": "Als produktiv markieren",
      "unmarkProductionPrompt": "Produktiv-Markierung entfernen von",
      "markProductionConfirm": "Als produktiv markieren",
      "unmarkProductionConfirm": "Entfernen",
      "createTitle": "Firmware-Version erstellen",
      "created": "Version „{{name}}“ erstellt",
      "productionLabel": "Produktiv",
      "fileHint": "Firmware-Binärdatei ({{ext}}) hochladen",
      "fileDropTitle": "Firmware-Datei ablegen oder zum Auswählen klicken",
      "cpuPlaceholder": "CPU-Typ auswählen",
      "fileHintArchive": "Firmware-Archiv ({{ext}}) hochladen",
      "createFailed": "Die Firmware-Version konnte nicht erstellt werden. Bitte erneut versuchen.",
      "versionExists": "Diese Version existiert bereits für den ausgewählten Gerätetyp",
      "fileRequired": "Wählen Sie eine Firmware-Datei zum Hochladen aus",
      "buildNumberExists": "Diese Build-Nummer existiert bereits für den ausgewählten Gerätetyp"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "assignments": "Zuweisungen"
      }
    },
    "assignments": {
      "empty": "Dieser Version sind keine Ketten, Filialen oder Geräte zugewiesen.",
      "frozen": "Eingefroren",
      "columns": {
        "scope": "Bereich",
        "target": "Ziel",
        "frozen": "Eingefroren",
        "assignedAt": "Zugewiesen",
        "id": "ID"
      },
      "scope": {
        "device": "Gerät",
        "store": "Filiale",
        "chain": "Kette"
      },
      "searchPlaceholder": "Zuweisungen suchen...",
      "searchScopes": "Bereiche suchen…",
      "noScopes": "Keine Bereiche gefunden"
    }
  },
  "updateAvailable": {
    "message": "Eine neue Version ist verfügbar.",
    "reload": "Neu laden"
  }
}
